import BaseApiAction from '@Actions/base-api-action';

export type GetTeamReportPayload = {
  user_ids: string[],
  from_date?: string,
  to_date?: string,
}

export default class GetTeamReport extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'v2-reports-getTeamReport',
      payload: { ...this._payload  },
    });
  }

  onError(response: any): void {
    super.onError(response);
    console.log('GetTeamReport error', response);
  }
}